import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { loginAsync } from "store/actions/authActions";
//#endregion
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { LoginFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { AuthEnums } from "models/enums";
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
//#endregion
//#region components
import UserNameLoginForm from "./userNameLoginForm";
//#endregion
import * as Yup from "yup";
import { UtilsHelper } from "utils/helpers";

const UserNameLoginFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const login = (user: ApiModels.AuthPost, loginMethod: AuthEnums.LoginMethod) =>
    dispatch(
      loginAsync(`PASSWORD_LOGIN_${UtilsHelper.getUniqueId()}`, user, loginMethod)
    ) as unknown as Promise<number>;

  const validationSchema = Yup.object<LoginFormTypes.UserNameLogin>({
    userName: Yup.string().required(TranslationKeys.Validations.Required),
    password: Yup.string().required(TranslationKeys.Validations.Required),
    rememberUser: Yup.boolean(),
  });

  const defaultValues: LoginFormTypes.UserNameLogin = {
    userName: "",
    password: "",
    rememberUser: true,
  };

  const handleSubmit = (values: LoginFormTypes.UserNameLogin) => {
    return login(
      {
        mail: (values as LoginFormTypes.UserNameLogin).userName,
        password: (values as LoginFormTypes.UserNameLogin).password,
      } as ApiModels.AuthPost,
      AuthEnums.LoginMethod.USERNAME_PASSWORD
    );
  };

  return (
    <UserNameLoginForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(UserNameLoginFormContainer);
